import React from 'react';
import { SEODashboard } from './components/SEODashboard';
export function App() {
  return <SEODashboard data-id="element-0" />;
}